export default __webpack_public_path__ + "static/media/ReadexPro-bold.10d21fbe.ttf";